import script from "./RechargeList.vue?vue&type=script&setup=true&lang=js"
export * from "./RechargeList.vue?vue&type=script&setup=true&lang=js"

import "./RechargeList.vue?vue&type=style&index=0&id=5ff5e4d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff5e4d0"]])

export default __exports__